export default __webpack_public_path__ + "static/media/cover.a7b99137.png";